module.exports = __webpack_public_path__ + "img/jiaoxue_title_bg.f6deed3a.png";